export const ICON_TYPES = {
  RIGHTARROW: 'rightarrow-svg',
  LEFTARROW: 'leftarrow-svg',
  MAIL: 'mail-svg',
  AREA: 'area-svg',
  BATH: 'bath-svg',
  BEDROOM: 'bedroom-svg',
  CALENDAR: 'calendar-svg',
  LOCATION: 'location-svg',
  CALL: 'call-svg',
  LENS: 'lens-svg',
  CLOCK: 'clock-svg',
  CLOSE: 'close-svg',
  WEB: 'web-svg',
  DOWNARROW: 'downarrow-svg',
  FILTER: 'filter-svg',
  CANCEL: 'cancel-svg',
  ALDHAR_LOGO_ALT: 'aldhar-logo-alt-svg',
  FACEBOOK: 'facebook-svg',
  INSTAGRAM: 'instagram-svg',
  TWITTER: 'twitter-svg',
  LINKDIN: 'linkedin-svg',
  BELL: 'bell-svg',
  EYE: 'eye-svg',
  GRID_VIEW: 'gridview-svg',
  LIST_VIEW: 'listview-svg',
  CHECKBOX: 'checkbox-svg',
  CHECKBOX_UNCHECK: 'uncheckbox-svg',
  CROSS_SMALL: 'cross-svg',
  LOADER_SMALL: 'loader-small-svg',
  LOADER_LARGE: 'loader-large-svg',
  DRAWER: 'drawer-svg',
  HAMBURGER: 'hamburger-svg',
  ALDHAR_LOGO: 'aldhar-logo-svg',
  BACK_ARROW: 'back-arrow-svg',
  FLOOR_PLAN: 'floor-plan-svg',
  COMMUNITY: 'community-icon',
  NO_PROPERTY_IMAGE: 'no-property-image-svg',
  NO_PLOT_IMAGE: 'no-plot-image-svg',
  SHARE: 'share-svg',
  WHATSAPP_LOGO: 'whatsapp-svg',
  FACEBOOK_LOGO: 'facebook-logo-svg',
  TWITTER_LOGO: 'twitter-logo-svg',
  AIR_CONDITIONER: 'air-conditioner-svg',
  TV_CABLE: 'tv-cable-svg',
  WIFI: 'wifi-svg',
  CLEANING_SERVICE: 'clean-service-svg',
  DINING_ROOM: 'dining-room-svg',
  BARBAQUE: 'barbaque-svg',
  CENTRAL_HEATING: 'central-heating-svg',
  OUTDOOR_SHOWER: 'outdoor-shower-svg',
  PARKING: 'parking-svg',
  DRYER: 'dryer-svg',
  MICROWAVE: 'microwave-svg',
  SWIMMING_POOL: 'swimming-pool-svg',
  REFRIGERATOR: 'refrigrator-svg',
  SAUNA: 'sauna-svg',
  PLAY_BUTTON: 'play-button-svg',
  GALLERY_ICON: 'gallery-svg',
  REFRESH_ICON: 'refresh-icon-svg',
  COPY_LINK: 'copy-link-svg',
  SUCCESS_TICK_ICON: 'success-tick-icon-svg',
  INFO: 'info-svg',
  COMMUNITY_PHASE_ICON: 'community-phase-icon-svg',
  PDF_ICON: 'pdf-icon-svg',
  SWIMMER_ICON: 'swimmer-icon-svg',
  GYM_ICON: 'gym-icon-svg',
  GOLF_ICON: 'golf-icon-svg',
  FITNESS_CENTER_ICON: 'fitness-center-icon-svg',
  GREEN_SPACE_ICON: 'green-space-icon-svg',
  PLAYGROUND_ICON: 'playground-icon-svg',
  TENIS_COURTS_ICON: 'tenis-courts-icon-svg',
  COMMUNITY_CENTER_ICON: 'community-center-icon-svg',
  LIBRARY_ICON: 'library-icon-svg',
  STEAM_ROOM_ICON: 'steam_room-icon-svg',
  BASKETBALL_COURT_ICON: 'basketball-court-icon-svg',
  BUSINESS_CENTER_ICON: 'business-center-icon-svg',
  FITNESS_STATION_ICON: 'fitness-station-icon-svg',
  VIEW_MORE_ARROW_ICON: 'view-more-arrow-icon-svg',
  ARROW_SMALL_RIGHT: 'arrow-small-right',
  PIXABAY: 'pixabay-svg',
  LANDICON: 'land-svg',
  BANK: 'bank-svg',
  FILE_PDF_ICON: 'file-pdf-svg',
  SHOPPING: 'shopping-svg',
  APARTMENT: 'apartment-svg',
  FITNESS: 'fitness-svg',
  FOOD: 'food-svg',
  HOSPITAL: 'hospital-svg',
  EMIRATES: 'emirates-svg',
  COMMUNITIES: 'communities-svg',
  PROJECTS: 'projects-svg',
  DEVELOPING_UNITS: 'developing-units-svg',
  PLOTS_FOR_SALE: 'plots-for-sale-svg',
  UNDER_BANK_MGMT: 'under-bank-mgmt-svg',
  EXPAND: 'expand-svg',
  SPINNER: 'spinner-svg',
  UP_RIGHT_ARROW: 'up-right-arrow-svg',
  DOWNLOAD_ICON: 'download-svg',
  FULL_SCREEN_ICON: 'full-screen-icon-svg',
  MINIMIZE_SCREEN_ICON: 'minimize-icon-svg',
  ARROW_UP: 'arrow-up',
  GREY_RIGHT_ARROW: 'grey-right-arrow',
  LIFE_STYLE_ICON: 'life-style-svg',
  REDIRECTS: 'redirect-svg',
  GATED_ACCESS: 'gated-access-icon-svg',
  FITNESS_TRAIL: 'fitness-trail-icon-svg',
  BEACH: 'beach-icon-svg',
  MOSQUES: 'mosques-icon-svg',
  MULTI_SPORTS_COURT: 'multipurpose-sports-court-svg',
  COMM_RETAIL_OUTLET: 'community-retail-outlet-svg',
  RUN_CYCLE_TRACK: 'running-cycling-track-svg',
  GREEN_SPACES: 'green-spaces-svg',
  SCHOOL: 'school-svg',
  KIDS_PLAY_AREA: 'kids-play-area-svg',
  ACTIVITIES: 'activities-svg',
  ART_SERVICE_ONE: 'art-service-one-svg',
  ART_SERVICE_TWO: 'art-service-two-svg',
  ART_SERVICE_THREE: 'art-service-three-svg',
  SLIDER_ARROW: 'slider-arrow-svg',
  EXPAND_ICON: 'expand-icon-svg',
  GRAPHIC_LEFT_ICON: 'graphic-arrow-left-svg',
  GRAPHIC_RIGHT_ICON: 'graphic-arrow-right-svg',
  GRAPHIC_DOWN_ICON: 'graphic-arrow-down-svg',
  QUOTE_ICON: 'quote-svg',
} as const;
